import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, takeUntil, withLatestFrom } from 'rxjs';
import * as fromRoot from '@app/reducers/index';
import { Store } from '@ngrx/store';
import { AccountActions } from '@app/core/actions';
import { TokenService } from '../token.service';
import { Subscription } from '@app/shared/models/subscription';
import { Language } from '@app/shared/types/Language';


@Injectable({
    providedIn: 'root'
})
export class ResolveSubscriptionService {

    constructor(
        private readonly store$: Store<fromRoot.State>,
        private tokenService: TokenService,
    ) { }

    resolve(): Observable<{ subscription: Subscription | null, isRoot: boolean, isAdmin: boolean, language: Language }> {
        const resolvedSubscription$ = new ReplaySubject<{ subscription: Subscription | null, isRoot: boolean, isAdmin: boolean, language: Language }>();
        this.store$.pipe(
            withLatestFrom(
                this.store$.select(fromRoot.getActiveIdentity),
                this.store$.select(fromRoot.getUserRolesLoading),
                this.store$.select(fromRoot.getUserRolesLoaded),
                this.store$.select(fromRoot.getIsAdministrator),
                this.store$.select(fromRoot.getSubscription),
                this.store$.select(fromRoot.getSubscriptionUpdating),
                this.store$.select(fromRoot.getSubscriptionLoaded),
                this.store$.select(fromRoot.getSelectedLanguage),
            ),
            takeUntil(resolvedSubscription$)
        ).subscribe(([store, identity, rolesLoading, rolesLoaded, isAdmin, subscription, subscriptionLoading, subscriptionLoaded, language]) => {

            const isRoot = this.tokenService.isRoot(identity?.token?.token);
            if (subscriptionLoaded) {
                resolvedSubscription$.next({ subscription, isRoot, isAdmin, language });
            } else if (!subscriptionLoading && (isRoot || isAdmin)) {
                this.store$.dispatch(AccountActions.loadSubscriptionWithPlan());
            } else if (!isRoot && !rolesLoading && !rolesLoaded) {
                this.store$.dispatch(AccountActions.LoadUserRoles());
            } else if (!isRoot && rolesLoaded && !isAdmin) {
                resolvedSubscription$.next({ subscription: null, isRoot, isAdmin, language });
            }
        });

        return resolvedSubscription$.asObservable();
    }
}